import Programs from '../../../global/Programs/Programs';

export default Programs;
